/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function setCookie(cname,cvalue,exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

$(function () {
  if($('.member-faqs').length !=0) {
  $('.member-faqs button')[0].click();
    
     
  }
  function render_read_more_btn() {
    var windowWidth = $(window).width();
    if (windowWidth <= 749) {
       var selector = $(
          ".modal--membership-popup .membership--newsletter__content #popup-desc"
        );
      var rmBtn = $(".modal--membership-popup .read-more-btn");
     // console.log(selector);
     if (
        selector.length != 0 && rmBtn.length == 0
      ) {
       
        selector.before(
          `<a href="javascript:void(0)" class="read-more-btn">Read More </a>`
        );
        selector.hide();
      }
      else {
        rmBtn.show();
        selector.hide();
      } 
    } else {
      $(".modal--membership-popup .read-more-btn").hide();
      $(".modal--membership-popup #popup-desc").show();
    }
  }
  $(document).on('click','.close-pop-up',function(){
    $('.modal--membership-popup').removeAttr('style');
  })
  $(document).on('click','.scroll-anchor a,.scroller-btn',function(e){
    e.preventDefault();
      var target = $(this).attr("href");
         $target = $(target);
       var header_height = $('.shopify-section__header').height();
    //console.log($target,header_height);
 
 $('html, body').stop().animate( {
      'scrollTop': $target.offset().top-(header_height+95)
    }, 900, 'swing', function () {
     // window.location.hash = target;
    } );
    
  
  
   // console.log("4333333333333",href);
    return false;
  })

  
  $(window).scroll(function() {    
      var fixedBtn = $('.scroller-btn');
    if(fixedBtn.length !=0) {
            var scroll = $(window).scrollTop();
    var topOffset = $('.scroller-btn-wrap').offset().top;
       var header_height = $('.shopify-section__header').height();
    var bottomOffset =  $('#member-form').offset().top  - ($('#member-form').outerHeight(true) + header_height); 
      if(scroll < topOffset) {
        fixedBtn.hide();
      }
      else fixedBtn.show();
   //  console.log($('#member-form').offset());
   //   console.log(bottomOffset, $('#member-form').offset().top,scroll,$('#member-form').outerHeight(true));
       if (scroll > bottomOffset) {
         fixedBtn.hide();
      }
  //  console.log(scroll,bottomOffset,$('.membership-form-wrap').offset())
    }
  });
  $(document).on("click", ".modal--membership-popup .read-more-btn", function (e) {
    e.preventDefault();
    $(".modal--membership-popup .read-more-btn").hide();
      $(".modal--membership-popup #popup-desc").slideDown();
  });
  
  $('body.become-a-member a').each(function(){
  //  e.preventDefault();
    var selector = $(this);
    var link = selector.attr('href');
    let isProductPage = link.indexOf("products/");
    if (-1 != isProductPage) {
        selector.attr('target','_blank');
    
    }
   // console.log(selector.attr('href'));    
  //  return false;
  })
  $(document).on("click", ".membership_modal", function (e) {
    e.preventDefault();
    $(".modal--membership-popup").attr("aria-hidden", false);
  });
  $(document).on("click", ".product-price-option", function (e) {
    $(this).find('.product-price-opt').prop('checked',true);
    var getVal =  $(this).find('.product-price-opt').val();
    $('.product-qty-info .cart-btn').hide();
    $('.product-qty-info .'+getVal+'-cart').show();
    console.log(getVal);
  });
    $(document).on("click", ".product-price-opt", function (e) {
      console.log("Test-----",$(this));
      $('.product-price-opt').prop("checked", false);
  $(this).prop("checked", true);
      var getVal =  $(this).val();
         $('.product-qty-info .cart-btn').hide();
       $('.product-qty-info .'+getVal+'-cart').show();
    console.log(getVal);
      
  });


 
  $(document).on("click", ".popup-membership__close", function () {
    var parent = $(this).parents(".modal");
    //  console.log(parent);
    parent.attr("aria-hidden", true);
  });
  var refer_link = document.referrer;

  
  if ($("form#customer_login").length != 0 && refer_link != "") {
      if($('#login-form-error').length !=0) {
         refer_link =  getCookie('document_referrer');
      }
    console.log(refer_link);
    var returnUrlSelector = $(".return_to");
   // var refer_link = document.referrer;
    refer_link = refer_link.replace(window.location.origin, "");
    let isProductPage = refer_link.indexOf("products/");
    if (-1 != isProductPage) {
      setCookie("document_referrer", refer_link, 1);
      returnUrlSelector.val(refer_link);
      $('.form#customer_login [name=return_url]').val(refer_link);
    } 
    let ismemberPage = refer_link.indexOf("pages/become-a-member");
    if (-1 != ismemberPage) {
      setCookie("document_referrer", '/', 1);
      returnUrlSelector.val('/');
      $('.form#customer_login [name=return_url]').val('/');
    } 
    
   // console.log(returnUrlSelector);
   // console.log(isProductPage);
  }

  

  if ($(".cs-video-slider").length != 0) {
    $(".cs-video-slider").slick({
      arrows: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      prevArrow:
        "<button type='button' class='slick-prev'><svg class='flickity-button-icon' viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z' class='arrow'></path></svg></button>",
      nextArrow:
        "<button type='button' class='slick-next'><svg class='flickity-button-icon' viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z' class='arrow' transform='translate(100, 100) rotate(180)'></path></svg></button>",
      autoplaySpeed: 5000,
    });
  }
});

$(document).ready(function() {
  $(document).on("click", ".stamped-product-reviews-badge", function () {
    $("html, body").animate(
      {
        scrollTop:
          $("#stamped-main-widget").offset().top -
          $(".shopify-section__header").height(),
      },
      2000
    );
  });
  
  if ($(".cs-single-video-slider").length != 0) {
    if($(".cs-single-video-slider .video-slide-item-1").length < 3) {
      $(".cs-single-video-slider").addClass("no-slider");
      return false;
    }
    $(".cs-single-video-slider").slick({
      arrows: false,
      dots: true,
      slidesToShow: 3,
      centerPadding: "0px",
      slidesToScroll: 1,
      infinite: true,
      centerMode: true,
     // autoplay: true,
      draggable: true,
      prevArrow:
        "<button type='button' class='slick-prev'><svg class='flickity-button-icon' viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z' class='arrow'></path></svg></button>",
      nextArrow:
        "<button type='button' class='slick-next'><svg class='flickity-button-icon' viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z' class='arrow' transform='translate(100, 100) rotate(180)'></path></svg></button>",
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            swipeToSlide: true,
            touchMove: true,
            draggable: true,
          },
        },
      ],
    });
  }
  if ($(".template-product .stamped-badge-caption").length != 0) {
    var count = parseInt($(".stamped-badge-caption").data("reviews"));
    console.log(count, count > 0);
    if (count > 0) $("#stamped-reviews-widget").hide();
  }

  setTimeout(() => {
    if ($("#aaa_memebership_form_btnform_cont_12005_lightBox .aaamembership_form").length != 0) {
      $("#aaa_memebership_form_btnform_cont_12005_lightBox .aaamembership_form .membership-submit")
        .append(`<div class="member-info-text"> <p> Checkout with member prices by starting your trial. After the trial period ends, we will charge your card with a monthly $4.99 fee.
<br>
In the event of membership cancellation during trial period, we will adjust your order to charge non-member pricing.
</p>
</div>`);
    }
  }, 4000);
});

var clipboard = new ClipboardJS(".btn-copy");

clipboard.on("success", function (e) {
  console.info("Action:", e.action);
  console.info("Text:", e.text);
  console.info("Trigger:", e.trigger);
  e.trigger.classList.add("tooltip");
  e.clearSelection();
  setTimeout(() => {
    e.trigger.classList.remove("tooltip");
  }, 2000);
});

clipboard.on("error", function (e) {
  console.error("Action:", e.action);
  console.error("Trigger:", e.trigger);
  // e.trigger.classList.remove("tooltip");
});
